<template>
	<Dialog v-bind:value="value" @input="$emit('input', $event)"
					title="Benutzer löschen ?"
					@ok="submit" ok-text="Fortfahren" :loading="loading"
					@cancel="$emit('input', false)">
		Soll der Benutzer mit der Mail
		<b>{{ selectedUser ? selectedUser.Mail : false }}</b>
		wirklich gelöscht werden? <br><br>
		Diese Aktion kann nicht mehr rückgängig gemacht werden.
	</Dialog>
</template>

<script>
import Dialog from "../../components/Dialog";

export default {
	components: {Dialog},
	props: ['value'],
	name: "DeleteUserDialog",
	data: () => {
		return {
			loading: false,
		}
	},
	computed: {
		vuexState() {
			return this.$store.state.users;
		},
		selectedUser() {
			return this.vuexState.selectedUser;
		},
	},
	methods: {
		async submit() {
			this.loading = true;
			try {
				let data = await this.$store.dispatch('users/deleteUser', {user_id: this.selectedUser.UserId});
				this.loading = false;
				if (data.Status) {
					this.$root.$emit('snackbar', this.selectedUser.Mail + ' erfolgreich gelöscht.');
					this.$emit('input', false);
					this.$emit('deleted');
				}
			} catch (e) {
				this.loading = false;
			}
		}
	}
}
</script>

<style scoped>

</style>